import Profile_Avatar0 from 'styles/assets/avatar/Profile_Avatar0.webp';
import Profile_Avatar1 from 'styles/assets/avatar/Profile_Avatar1.webp';
import Profile_Avatar2 from 'styles/assets/avatar/Profile_Avatar2.webp';
import Profile_Avatar3 from 'styles/assets/avatar/Profile_Avatar3.webp';
import Profile_Avatar4 from 'styles/assets/avatar/Profile_Avatar4.webp';
import Profile_Avatar5 from 'styles/assets/avatar/Profile_Avatar5.webp';
import Profile_Avatar6 from 'styles/assets/avatar/Profile_Avatar6.webp';
import Profile_Avatar7 from 'styles/assets/avatar/Profile_Avatar7.webp';
import Profile_Avatar8 from 'styles/assets/avatar/Profile_Avatar8.webp';
import Profile_Avatar9 from 'styles/assets/avatar/Profile_Avatar9.webp';
import Profile_Avatar10 from 'styles/assets/avatar/Profile_Avatar10.webp';
import Profile_Avatar11 from 'styles/assets/avatar/Profile_Avatar11.webp';
import Profile_Avatar12 from 'styles/assets/avatar/Profile_Avatar12.webp';
import Profile_Avatar13 from 'styles/assets/avatar/Profile_Avatar13.webp';
import Profile_Avatar14 from 'styles/assets/avatar/Profile_Avatar14.webp';
import Profile_Avatar15 from 'styles/assets/avatar/Profile_Avatar15.webp';
import Profile_Avatar16 from 'styles/assets/avatar/Profile_Avatar16.webp';
import Profile_Avatar17 from 'styles/assets/avatar/Profile_Avatar17.webp';
import Profile_Avatar18 from 'styles/assets/avatar/Profile_Avatar18.webp';
import Profile_Avatar19 from 'styles/assets/avatar/Profile_Avatar19.webp';
import Profile_Avatar20 from 'styles/assets/avatar/Profile_Avatar20.webp';
import Profile_Avatar21 from 'styles/assets/avatar/Profile_Avatar21.webp';
import Profile_Avatar22 from 'styles/assets/avatar/Profile_Avatar22.webp';
import Profile_Avatar23 from 'styles/assets/avatar/Profile_Avatar23.webp';

export const avatar = {
  '/avatar/Profile_Avatar0.webp': Profile_Avatar0,
  '/avatar/Profile_Avatar1.webp': Profile_Avatar1,
  '/avatar/Profile_Avatar2.webp': Profile_Avatar2,
  '/avatar/Profile_Avatar3.webp': Profile_Avatar3,
  '/avatar/Profile_Avatar4.webp': Profile_Avatar4,
  '/avatar/Profile_Avatar5.webp': Profile_Avatar5,
  '/avatar/Profile_Avatar6.webp': Profile_Avatar6,
  '/avatar/Profile_Avatar7.webp': Profile_Avatar7,
  '/avatar/Profile_Avatar8.webp': Profile_Avatar8,
  '/avatar/Profile_Avatar9.webp': Profile_Avatar9,
  '/avatar/Profile_Avatar10.webp': Profile_Avatar10,
  '/avatar/Profile_Avatar11.webp': Profile_Avatar11,
  '/avatar/Profile_Avatar12.webp': Profile_Avatar12,
  '/avatar/Profile_Avatar13.webp': Profile_Avatar13,
  '/avatar/Profile_Avatar14.webp': Profile_Avatar14,
  '/avatar/Profile_Avatar15.webp': Profile_Avatar15,
  '/avatar/Profile_Avatar16.webp': Profile_Avatar16,
  '/avatar/Profile_Avatar17.webp': Profile_Avatar17,
  '/avatar/Profile_Avatar18.webp': Profile_Avatar18,
  '/avatar/Profile_Avatar19.webp': Profile_Avatar19,
  '/avatar/Profile_Avatar20.webp': Profile_Avatar20,
  '/avatar/Profile_Avatar21.webp': Profile_Avatar21,
  '/avatar/Profile_Avatar22.webp': Profile_Avatar22,
  '/avatar/Profile_Avatar23.webp': Profile_Avatar23,
};
